import Cookies from 'js-cookie';
import { thunkRegistry } from "../slices/thunkRegistry";
import { postLogin } from "./fakebackend_helper";
import { setAuthUser } from "./utils";
import { logoutUser } from "../slices/thunks";
import { tokenRefreshStarted, tokenRefreshFinished } from '../slices/tokenRefresh/reducer';


let isRefreshing = false;
let requestQueue = [];

export const authMiddleware = ({ dispatch, getState }) => (next) => async (action) => {
  if (typeof action !== 'object' || !action.type?.endsWith('/rejected')) {
    return next(action);
  }

  const error = action.payload || action.error;

  const originalRequest = action.meta?.arg || action.url;
  
  if (error?.status === 401 || error?.message?.includes('401')) {
    const thunkType = action.type.replace('/rejected', '');
    
    const thunkCreator = thunkRegistry[thunkType];

    // Add to retry queue
    if (thunkCreator) {
      requestQueue.push(() => {
        if (originalRequest !== undefined) {
          dispatch(thunkCreator(originalRequest));
        } else {
          dispatch(thunkCreator()); // retry without payload
        }
      });
    }


    if (!isRefreshing) {
      isRefreshing = true;
      dispatch(tokenRefreshStarted());

      try {
        const response = await postLogin({ refreshToken: Cookies.get("customToken") }); 
        const newToken = response?.data?.authToken;

        if (!newToken) {
          throw new Error("No refresh token received");
        }

        setAuthUser(response.data);

        // Retry all queued actions
        while (requestQueue.length > 0) {
          const retry = requestQueue.shift();
          retry();
        }
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
        dispatch(logoutUser());
        requestQueue = []; 
      } finally {
        dispatch(tokenRefreshFinished());
        isRefreshing = false;
      }
    }
    return;
  }

  return next(action);
};